import React from 'react';
import Layout from '../../components/Layout';
import Blog from './Blog';

const title = 'BestHand Guides & Tips — Coming Soon';
const description =
  'Practical guides and tips for hiring trusted local pros — how to prep for a visit, what jobs cost, and how to hire a vetted pro. Our guides hub is coming soon.';

function action() {
  return {
    title,
    description,
    component: (
      <Layout>
        <Blog />
      </Layout>
    ),
  };
}

export default action;
